import {ScreenNames} from '../../../lib/analytics/events';
import {BaseScreen, ScreenDivider, ScreenHeader} from '../Screen';
import {UserLoader} from '../../../components/UserLoader';
import {toast, ToastContainer} from 'react-toastify';
import React from 'react';
import {ReactComponent as UsersCheckIcon} from 'src/assets/icons/users-check.svg';
import {UserProfileInterface} from '../../../reducers/users';
import {DataLoader} from '../../../components/DataLoader';
import UserMgmtCrud from './api';
import {UserAccess} from './types';
import {DateTime} from 'luxon';

const styles = {
    table: 'table-fixed w-full text-center',
    tr: '',
    th: 'p-2',
    td: 'p-2 text-center',
    tdLeft: 'p-2 text-left',
};

function ResponseForm(props: {access: UserAccess; onResponse: () => void}) {
    const [loading, setLoading] = React.useState<boolean>(false);

    const {access, onResponse} = props;

    const processResponse = (response: boolean) => {
        setLoading(true);
        UserMgmtCrud.respond_invite(access.organization_uid, response ? 'accept' : 'decline')
            .then((result) => {
                if (!!result.error) throw result.error;
                onResponse();
                if (response) {
                    toast(`You are now a part of the ${access.organization_name} organization.`, {type: 'success'});
                } else {
                    toast(`You have declined the invitation from ${access.organization_name}.`, {type: 'warning'});
                }
            })
            .catch((err) => {
                toast('Failed to respond to invitation. Error: ' + (err.message ?? 'unknown error'), {
                    type: 'error',
                });
            });
    };

    return (
        <>
            <button
                disabled={loading}
                className={'m-2 mr-2 rounded-md bg-green-500 p-2 text-white'}
                onClick={() => processResponse(true)}>
                Accept
            </button>
            <button
                disabled={loading}
                className={'m-2 rounded-md bg-red-500 p-2 text-white'}
                onClick={() => processResponse(false)}>
                Decline
            </button>
        </>
    );
}

function UserInviteMgmt(props: {access: UserAccess[]}) {
    let [access, setAccess] = React.useState<UserAccess[]>(props.access);

    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    <th className={styles.th}>Organization</th>
                    <th className={styles.th}>Date</th>
                    <th className={styles.th}>Response</th>
                </tr>
            </thead>
            <tbody>
                {access.map((a) => {
                    return (
                        <tr key={a.organization_uid} className={styles.tr}>
                            <td className={styles.tdLeft}>{a.organization_name}</td>
                            <td className={styles.td}>
                                {DateTime.fromISO(a.updated_at).toLocaleString(DateTime.DATETIME_MED)}
                            </td>
                            <td className={styles.td}>
                                <ResponseForm
                                    key={a.organization_uid}
                                    access={a}
                                    onResponse={() => {
                                        let newAccess = access.filter((u) => u.organization_uid !== a.organization_uid);
                                        setAccess(newAccess);
                                    }}
                                />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}

function BaseFetch(props: {user: UserProfileInterface}) {
    return (
        <DataLoader
            loader={async () => {
                const result = await UserMgmtCrud.my_invites();
                if (!!result.error) throw result.error;
                return result.data ?? [];
            }}>
            {(data) => <UserInviteMgmt access={data} />}
        </DataLoader>
    );
}

export function UserInvitationScreen() {
    const {USER_MANAGEMENT} = ScreenNames;

    return (
        <BaseScreen screenName={USER_MANAGEMENT}>
            <ScreenHeader icon={<UsersCheckIcon className={'stroke-black'} />} title={'User Invitations'} />
            <ScreenDivider />
            <UserLoader>{(user) => <BaseFetch user={user} />}</UserLoader>
            <ToastContainer />
        </BaseScreen>
    );
}
